// extracted by mini-css-extract-plugin
export default {"base":"DialogEdgeAlert_base__VtR2m","content":"DialogEdgeAlert_content__dWGtw","button":"DialogEdgeAlert_button__LlGYf"};